var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isKedu)?_c('school-form',_vm._b({on:{"success":_vm.onSuccess,"cancel":_vm.onCancel}},'school-form',_vm.$attrs,false)):_c('contact-form',_vm._b({on:{"success":_vm.onSuccess,"cancel":_vm.onCancel}},'contact-form',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }